import { Navigate, type RouteObject } from 'react-router-dom'
import Layout from '@presentation/components/layout/Layout'
import HomePage from '@presentation/screens/HomePage'
import AboutPage from '@presentation/screens/AboutPage'
import NewsListPage from '@presentation/screens/News/NewsListPage'
import NewsDetailPage from '@presentation/screens/News/NewsDetailPage'
import NewsDetailEditPage from '@presentation/screens/News/NewsDetailEditPage'
import WebinarListPage from '@presentation/screens/Webinars/WebinarListPage'
import WebinarDetailPage from '@presentation/screens/Webinars/WebinarDetailPage'
import WebinarDetailEditPage from '@presentation/screens/Webinars/WebinarDetailEditPage'
import WebinarSuggestionCommentsPage from '@presentation/screens/Webinars/WebinarSuggestionCommentsPage'
import WebinarSuggestionsPage from '@presentation/screens/Webinars/WebinarSuggestionsPage'
import PodcastListPage from '@presentation/screens/Podcasts/PodcastListPage'
import PodcastDetailPage from '@presentation/screens/Podcasts/PodcastDetailPage'
import InstagramReelsListPage from '@presentation/screens/InstagramReels/InstagramReelsListPage'
import InstagramReelDetailPage from '@presentation/screens/InstagramReels/InstagramReelDetailPage'
import HacksListPage from '@presentation/screens/Hacks/HacksListPage'
import HackDetailPage from '@presentation/screens/Hacks/HackDetailPage'
import HackDetailEditPage from '@presentation/screens/Hacks/HackDetailEditPage'
import HackWhatWorksCommentsPage from '@presentation/screens/Hacks/HackWhatWorksCommentsPage'
import UserNotificationsPage from '@presentation/screens/UserNotificationsPage'
import UserFavoritesPage from '@presentation/screens/UserFavoritesPage'
import MedicalDisclaimerPage from '@presentation/screens/Legal/MedicalDisclaimerPage'
import PrivacyPolicyPage from '@presentation/screens/Legal/PrivacyPolicyPage'
import TermsOfServicePage from '@presentation/screens/Legal/TermsOfServicePage'
import CookiePolicyPage from '@presentation/screens/Legal/CookiePolicyPage'
import FaqsPage from '@presentation/screens/Legal/FaqsPage'
import NotFoundPage from '@presentation/screens/NotFoundPage'

export const appRoutes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/about', element: <AboutPage /> },
      { path: '/news', element: <NewsListPage /> },
      { path: '/favorites', element: <UserFavoritesPage /> },
      { path: '/news/favorites', element: <Navigate to="/favorites" replace /> },
      { path: '/notifications', element: <UserNotificationsPage /> },
      { path: '/news/create', element: <NewsDetailEditPage /> },
      { path: '/news/:activityId/edit', element: <NewsDetailEditPage /> },
      { path: '/news/:activityId', element: <NewsDetailPage /> },
      { path: '/webinars', element: <WebinarListPage /> },
      { path: '/webinars/latest', element: <WebinarListPage /> },
      { path: '/webinars/upcoming', element: <WebinarListPage /> },
      {
        path: '/webinars/suggestions',
        element: <WebinarSuggestionsPage />,
      },
      {
        path: '/webinars/suggestions/:suggestionId/comments',
        element: <WebinarSuggestionCommentsPage />,
      },
      { path: '/webinars/create', element: <WebinarDetailEditPage /> },
      { path: '/webinars/:webinarId/edit', element: <WebinarDetailEditPage /> },
      { path: '/webinars/:webinarId', element: <WebinarDetailPage /> },
      { path: '/prof-bas-bloem-weekly', element: <PodcastListPage /> },
      { path: '/prof-bas-bloem-weekly/:episodeId', element: <PodcastDetailPage /> },
      { path: '/dr-michael-okun-my-take', element: <InstagramReelsListPage /> },
      {
        path: '/dr-michael-okun-my-take/:reelId',
        element: <InstagramReelDetailPage />,
      },
      { path: '/hacks', element: <HacksListPage /> },
      { path: '/hacks/create', element: <HackDetailEditPage /> },
      { path: '/hacks/:symptomId/edit', element: <HackDetailEditPage /> },
      {
        path: '/hacks/:symptomId/what-works/:whatWorkId/comments',
        element: <HackWhatWorksCommentsPage />,
      },
      { path: '/hacks/:symptomId', element: <HackDetailPage /> },
      {
        path: '/legal/medical-disclaimer',
        element: <MedicalDisclaimerPage />,
      },
      { path: '/legal/privacy-policy', element: <PrivacyPolicyPage /> },
      { path: '/legal/terms-of-service', element: <TermsOfServicePage /> },
      { path: '/legal/cookie-policy', element: <CookiePolicyPage /> },
      { path: '/legal/faqs', element: <FaqsPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]
